export default {
  // 页面标题
  'pages.device.register.title': '设备终端',
  'pages.device.register.subtitle': '管理POS设备授权、绑定及BIR税务合规信息',

  // 统计卡片
  'pages.device.register.stat.total': '设备总数',
  'pages.device.register.stat.online': '在线设备',
  'pages.device.register.stat.offline': '离线设备',
  'pages.device.register.stat.compliant': '合规设备',
  'pages.device.register.stat.onlineRate': '在线率',

  // 按钮
  'pages.device.register.export': '导出',
  'pages.device.register.registerDevice': '注册设备',
  'pages.device.register.copy': '复制',
  'pages.device.register.edit': '编辑',
  'pages.device.register.save': '保存',
  'pages.device.register.cancel': '取消',
  'pages.device.register.confirm': '确定',
  'pages.device.register.back': '返回',

  // 提示消息
  'pages.device.register.message.exportDeveloping': '导出功能开发中...',
  'pages.device.register.exportFileName': '设备列表',
  'pages.device.register.message.exportSuccess': '导出成功',
  'pages.device.register.message.exportFailed': '导出失败',
  'pages.device.register.message.wrongPassword': '密码错误',
  'pages.device.register.message.deleteSuccess': '删除成功',
  'pages.device.register.message.deleteFailed': '删除失败',
  'pages.device.register.message.registerSuccess': '注册成功',
  'pages.device.register.message.copySuccess': '复制成功',
  'pages.device.register.message.editSuccess': '编辑成功',
  'pages.device.register.message.editFailed': '编辑失败',
  'pages.device.register.message.fetchStoreFailed': '获取门店列表失败',

  // 删除弹窗
  'pages.device.register.deleteConfirm': '删除确认',
  'pages.device.register.deleteConfirmText': '请输入密码确认删除操作：',
  'pages.device.register.deletePasswordPlaceholder': '请输入密码',

  // 搜索
  'pages.device.register.search.placeholder': '搜索设备名称、序列号(SN)',

  // 通用标签（表格列、表单、详情共用）
  'pages.device.register.deviceId': '设备ID',
  'pages.device.register.deviceName': '设备名称',
  'pages.device.register.deviceType': '设备类型',
  'pages.device.register.store': '所属门店',
  'pages.device.register.tenant': '所属租户',
  'pages.device.register.snCode': '序列号',
  'pages.device.register.activationStatus': '激活状态',
  'pages.device.register.activationCode': '激活码',
  'pages.device.register.onlineStatus': '在线状态',
  'pages.device.register.onlineStatus.online': '在线',
  'pages.device.register.onlineStatus.offline': '离线',
  'pages.device.register.expireDate': '到期日期',
  'pages.device.register.terminalNo': '终端号',

  // 表格列（独有）
  'pages.device.register.column.deviceCode': '设备硬件编码',
  'pages.device.register.column.os': '操作系统',
  'pages.device.register.column.expiryDays': '使用期限',
  'pages.device.register.column.action': '操作',
  'pages.device.register.column.bappBound': 'BAPP 绑定',
  'pages.device.register.column.version': '版本号',
  'pages.device.register.tag.bound': '已绑 {date}',
  'pages.device.register.tag.unbound': '未绑',

  // 解绑 BAPP
  'pages.device.register.message.unbindBappSuccess': 'BAPP 解绑成功',
  'pages.device.register.message.unbindBappFailed': 'BAPP 解绑失败',
  'pages.device.register.unbindBapp.title': '解绑 BAPP',
  'pages.device.register.unbindBapp.confirm': '确认解绑',
  'pages.device.register.unbindBapp.cancel': '取消',
  'pages.device.register.unbindBapp.warning':
    '设备 {name} 已绑定 BAPP（SN: {sn}），解绑后该 BAPP 将无法继续使用，确定继续吗？',

  // 分区标题
  'pages.device.register.divider.basicInfo': '基础信息',
  'pages.device.register.divider.otherInfo': '其他信息',

  // 表单 - 通用
  'pages.device.register.form.input': '请输入',
  'pages.device.register.form.select': '请选择',
  'pages.device.register.form.selectDate': '请选择',

  // 表单 - 校验与占位
  'pages.device.register.form.tenantPlaceholder': '请选择租户',
  'pages.device.register.form.tenantRequired': '请选择所属租户',
  'pages.device.register.form.storePlaceholder': '请选择门店',
  'pages.device.register.form.storePlaceholderDisabled': '请先选择租户',
  'pages.device.register.form.storeRequired': '请选择所属门店',
  'pages.device.register.form.deviceNameRequired': '请输入设备名称',
  'pages.device.register.form.deviceNamePlaceholder': '如：前台收银机 01',
  'pages.device.register.form.deviceTypeRequired': '请选择设备类型',
  'pages.device.register.form.expireDatePlaceholder': '请选择到期日期',
  'pages.device.register.form.expireDatePlaceholderEdit': '选择授权截止日期',
  'pages.device.register.form.expireDateRequired': '请选择到期日期',
  'pages.device.register.form.expireDateValidator': '到期日期不得早于当前日期',
  'pages.device.register.form.expireDateTooltip': '默认跟随租户订阅到期日',
  'pages.device.register.form.terminalNoRequired': '请输入终端号',

  // 表单 - 其他信息标签
  'pages.device.register.minNo': 'MIN号码',
  'pages.device.register.ptuNo': 'PTU号码',
  'pages.device.register.issueDate': '发行日期',
  'pages.device.register.accNo': '认证号',
  'pages.device.register.softwareName': '软件名称',

  // 详情弹窗
  'pages.device.register.detail.title': '设备详情',
  'pages.device.register.detail.basicInfo': '基本信息',
  'pages.device.register.detail.ptuInfo': 'PTU信息',

  // 编辑弹窗
  'pages.device.register.editTitle': '编辑设备',

  // 新增弹窗
  'pages.device.register.addTitle': '注册设备',
};
